import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SharedUtilService } from '../../util.service';
import { InfoParams } from '../info';

@Component({
  selector: 'orgbrain-errordialog',
  templateUrl: './errordialog.component.html',
  styleUrls: ['../dialog.component.scss'],
  standalone: false,
})
export class ErrorDialogComponent {
  data = inject<InfoParams>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<ErrorDialogComponent>>(MatDialogRef);
  util = inject(SharedUtilService);

  trustedHtml: SafeHtml;
  errorHtml: SafeHtml;
  constructor() {
    const data = this.data;
    const sanitizer = inject(DomSanitizer);

    this.trustedHtml = data.message && sanitizer.bypassSecurityTrustHtml(data.message);
    this.errorHtml = sanitizer.bypassSecurityTrustHtml(this.util.sensibleMessage(data.error));
    console.error(data.error);
  }
}
